export default __webpack_public_path__ + "static/media/img1.1a5a4f44.png";